module.exports = __webpack_public_path__ + "static/img/2.d9c4762.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/2.png
// module id = dMXo
// module chunks = 0